import { createContext } from "react";

export const IsSidebarOpenContext = createContext<boolean>(false);
export const SetIsSidebarOpenContext = createContext<
  React.Dispatch<React.SetStateAction<boolean>>
>(() => {});
